export { WarrantyReturnsParagraph } from './warrantyReturns-paragraph';
export { WarrantyReturnsPageContainer } from './warrantyReturns-page-container';
